




































































import { WithConfirmModal } from '@/components/organisms/confirm-modal/with-confirm-modal'
import ConfirmModal from '@/components/organisms/ConfirmModal.vue'

import PreviewService from '@/services/api/preview'
import { CookieService } from '@/services/cookie'

import { DateFormat } from '@/util/format'
import LoadingMixin from '@spa/mixins/loading'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

@Component({
  components: {
    ConfirmModal,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class PreviewNotification extends Mixins<WithConfirmModal>(WithConfirmModal) {
  async mounted() {
    const previewTime = CookieService.timeTravelTime

    if (!previewTime) {
      return
    }

    if (!DateFormat.validate(previewTime)) {
      this.$notify({
        group: this.notificationErrorGroup,
        type: 'error',
        duration: -1,
        title: 'プレビューできません',
        text: `不正なフォーマット: ${previewTime}`,
      })

      return
    }

    this.$notify({
      group: this.notificationGroup,
      duration: -1,
      title: 'プレビュー中',
      text: previewTime,
    })
  }

  async close() {
    const confirmed = await this.confirm()
    if (!confirmed) {
      return
    }

    await this.previewService.disable()

    this.$notify({
      group: this.notificationGroup,
      clean: true,
    })

    location.href = '/'
  }

  private get notificationGroup() {
    return 'preview'
  }

  private get notificationErrorGroup()  {
    return 'preview-error'
  }

  private get previewService() {
    return new PreviewService()
  }
}
